import { GAME_MESSAGE } from 'constant/game'
import { compareVersion, VersionCompareResult } from 'utils/versionUtil'
import { selectUserInfo } from 'redux/selector/user'
import { useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'
import { CONFIRM_MODAL_TYPE } from 'component/Modal/ConfirmModal'
import useConfirmModal from './useConfirmModal'
import { getLandingDomains } from 'api'

interface GameUserStatus {
  isExist?: boolean
  status?: boolean
}

type AccessValidationCallback = () => unknown

interface GameBanCheckResult {
  userCanEnter: boolean
  blockMessage: string
  compareResult: VersionCompareResult
  validateUser: (callback?: AccessValidationCallback) => boolean
}

export function useGameBanCheck(userStatus: GameUserStatus): GameBanCheckResult {
  const userInfo = useSelector((state: any) => selectUserInfo(state))
  const { openConfirm } = useConfirmModal()
  const compareResult = compareVersion(userInfo.register_version, process.env.REACT_APP_MOST_MINI_GAME_ACCESS_VERSION!)
  const userCanEnter = !(userStatus.isExist === true && userStatus.status === false) && compareResult !== 'less'

  const blockMessage = compareResult === 'less' ? GAME_MESSAGE.VERSION_TOO_LOW : GAME_MESSAGE.BAN_NOTICE

  const landingUrl = useMemo(() => {
    if (process.env.REACT_APP_LANDING_PAGE_HOST) return 'https://' + process.env.REACT_APP_LANDING_PAGE_HOST
  }, [])

  const validateUser = useCallback(
    (callback?: AccessValidationCallback) => {
      if (!userCanEnter) {
        if (compareResult === 'less') {
          openConfirm({
            message: GAME_MESSAGE.VERSION_TOO_LOW,
            type: landingUrl ? CONFIRM_MODAL_TYPE.OK_CANCEL_CUSTOM : CONFIRM_MODAL_TYPE.OK,
            confirmText: '前往官网',
            cancelText: '关闭',
            onConfirm: async () => {
              const sub = window.open('', '_blank')
              try {
                const landing = await getLandingDomains()
                const links = landing?.data?.map((i: any) => i.domain_name) ?? []
                const selected = links[~~(Math.random() * links.length)]
                if (selected) (sub as Window).location.replace(selected)
                else (sub as Window).location.replace(landingUrl!)
              } catch {
                ;(sub as Window).location.replace(landingUrl!)
              }
            },
          })
        } else {
          openConfirm({
            message: GAME_MESSAGE.BAN_NOTICE,
            type: CONFIRM_MODAL_TYPE.OK,
          })
        }
        return false
      }

      callback?.()
      return true
    },
    [compareResult, landingUrl, openConfirm, userCanEnter]
  )

  return {
    userCanEnter,
    blockMessage,
    compareResult,
    validateUser,
  }
}
